// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Date from "../../util/Date.js";
import * as Buhta_cabinet__DummyTable from "../../components/molecules/Table/DummyTable.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__PageNav from "../../components/molecules/PageNav.js";
import * as Buhta_cabinet__PayrollHrm from "../../grpc/PayrollHrm.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__Search from "../../components/molecules/Search/Search.js";
import * as Buhta_cabinet__Table2 from "../../components/molecules/Table/Table2.js";
import * as Buhta_components__CopyButton from "../../../../../packages/components/src/CopyButton.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function HrmEmployeesPage$HrmTableShimmer(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-5 h-5 rounded"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-40 h-5 rounded"
                  })
                ],
                className: "flex gap-1"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-10 h-5 rounded"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-6 h-6 rounded"
                  })
                ],
                className: "flex gap-1"
              })
            ],
            className: "flex justify-between items-center w-[343px] px-4 mx-4 my-3 rounded-sm shadow-search py-3 bg-white"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-white w-74 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-20 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-34 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-30 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-39 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-full h-4 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-full h-4 rounded"
              })
            ],
            className: "flex bg-gray-pale gap-2 px-4 py-3 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-74 h-5 rounded-sm shrink-0"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale w-50 h-4 rounded-sm shrink-0"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-4 py-2.5 border-b items-center border-gray-main"
          })
        ],
        className: "flex-1"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              className: "bg-white w-5 h-5 rounded-sm ml-4"
            }),
            JsxRuntime.jsx("div", {
              className: "bg-white w-22 h-5 rounded"
            }),
            JsxRuntime.jsx("div", {
              className: "bg-white w-5 h-5 rounded-sm ml-2"
            })
          ],
          className: "flex items-center w-full justify-between"
        }),
        className: "flex bg-gray-pale justify-center px-4 py-4 mt-6"
      })
    ]
  });
}

const HrmTableShimmer = {
  make: HrmEmployeesPage$HrmTableShimmer
};

function HrmEmployeesPage(Props) {
  let org = Props.org;
  let openMenu = Props.openMenu;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match$1 = React.useState(function () {
    return 1;
  });
  const setPage = match$1[1];
  const page = match$1[0];
  const match$2 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__PayrollHrm.EmployeeService.grid, undefined);
  const grid = match$2[0];
  const count = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Belt__Belt_List.length(grid.VAL);
  let rows;
  if (typeof grid === "string" || grid.NAME !== "Data") {
    rows = /* [] */ 0;
  } else {
    const __x = grid.VAL;
    rows = Belt__Belt_List.mapWithIndex(__x, (function (i, item) {
      const emptyInfo = Curry.app(Buhta_cabinet__PayrollHrm.EmploymentInfo.make, [
        undefined,
        undefined,
        undefined,
        undefined,
        "Сотрудник",
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ]);
      const emp = item.employment;
      const employment = emp !== undefined ? emp : Curry._8(Buhta_cabinet__PayrollHrm.Employment.make, undefined, undefined, undefined, undefined, emptyInfo, undefined, undefined, undefined);
      const info = Belt__Belt_Option.getWithDefault(employment.info, emptyInfo);
      const fullName = Stdlib__String.concat(" ", {
        hd: item.family_name,
        tl: {
          hd: item.given_name,
          tl: {
            hd: item.patronymic_name,
            tl: /* [] */ 0
          }
        }
      });
      const match = info.employment_type;
      let employmentTypeLabel;
      switch (match) {
        case /* EMPLOYMENT_TYPE_UNSPECIFIED */ 0 :
          employmentTypeLabel = "—";
          break;
        case /* EMPLOYMENT_TYPE_SALARY */ 1 :
          employmentTypeLabel = "ТД";
          break;
        case /* EMPLOYMENT_TYPE_CONTRACT */ 2 :
          employmentTypeLabel = "ГПХ";
          break;
      }
      const date = employment.start_date;
      const cells_0 = {
        body: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
              className: "flex items-center gap-1 w-full",
              children: [
                fullName,
                JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                  text: fullName
                })
              ]
            }),
            JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
              className: "text-gray-medium flex items-center gap-1",
              children: [
                info.position !== "" ? info.position : "—",
                info.position !== "" ? JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                    text: info.position,
                    small: true
                  }) : null
              ]
            })
          ],
          className: "flex-col w-max"
        }),
        style: "col-span-4 lg:col-span-3"
      };
      const cells_1 = {
        hd: {
          body: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
            className: "flex items-center gap-1",
            children: [
              employmentTypeLabel,
              JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                text: employmentTypeLabel
              })
            ]
          }),
          style: ""
        },
        tl: {
          hd: {
            body: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
              className: "flex items-center gap-1",
              children: [
                item.tin !== "" ? item.tin : "—",
                JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                  text: item.tin
                })
              ]
            }),
            style: ""
          },
          tl: {
            hd: {
              body: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                  className: "ml-1 flex items-center gap-1",
                  children: [
                    item.phone !== "" ? Formating.formatPhone(item.phone) : "—",
                    JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                      text: item.phone
                    })
                  ]
                }),
                className: "flex items-center w-max"
              }),
              style: ""
            },
            tl: {
              hd: {
                body: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: date !== undefined ? Buhta_cabinet__Date.toString(date) : "—"
                }),
                style: "justify-end"
              },
              tl: /* [] */ 0
            }
          }
        }
      };
      const cells = {
        hd: cells_0,
        tl: cells_1
      };
      const Key = String(i);
      return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
        cells: cells,
        route: contextRoute({
          TAG: /* Hrm */ 5,
          _0: {
            TAG: /* Employees */ 0,
            _0: {
              TAG: /* View */ 0,
              _0: item.id
            }
          }
        })
      }, Key);
    }));
  }
  const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
      title: "Сотрудники",
      leftChildren: JsxRuntime.jsx("img", {
        className: "w-6 h-6",
        alt: "buhta-people",
        src: StaticAsset.src("/static/icons/people-white-20.svg")
      }),
      openMenu: openMenu,
      rightChildren: JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
        route: contextRoute({
          TAG: /* Hrm */ 5,
          _0: {
            TAG: /* Employees */ 0,
            _0: /* Create */ 1
          }
        }),
        className: "bg-links flex rounded-sm px-3 py-2 hover:bg-links-hover active:bg-links-active",
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/plus.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.H6.make, {
            className: "ml-1 text-white",
            children: "Сотрудник"
          })
        ]
      })
    }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: "Сотрудники",
      rightChildren: JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
        route: contextRoute({
          TAG: /* Hrm */ 5,
          _0: {
            TAG: /* Employees */ 0,
            _0: /* Create */ 1
          }
        }),
        className: "bg-links flex rounded-sm px-3 py-2 hover:bg-links-hover active:bg-links-active",
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/plus.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.H6.make, {
            className: "ml-1 text-white",
            children: "Новый сотрудник"
          })
        ]
      })
    });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Buhta_cabinet__Search.make, {
          dispatch: match$2[1],
          page: page,
          setPage: setPage,
          searchLength: 1,
          showFilter: true,
          className: Cn.on("hidden", count <= 0)
        }),
        typeof grid === "string" ? (
            grid === "Loading" ? (
                deviceType === "mobile" ? JsxRuntime.jsx(HrmEmployeesPage$HrmTableShimmer, {}) : JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {})
              ) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
          ) : (
            grid.NAME === "Data" ? JsxRuntime.jsxs(React.Fragment, {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
                        header: count <= 0 ? /* [] */ 0 : ({
                            hd: {
                              name: "ФИО",
                              style: "col-span-4 lg:col-span-3"
                            },
                            tl: {
                              hd: {
                                name: "Вид",
                                style: "w-max lg:w-full"
                              },
                              tl: {
                                hd: {
                                  name: "ИИН",
                                  style: ""
                                },
                                tl: {
                                  hd: {
                                    name: "Номер телефона",
                                    style: "w-full"
                                  },
                                  tl: {
                                    hd: {
                                      name: "Дата начала работы",
                                      style: "w-max lg:w-full text-right"
                                    },
                                    tl: /* [] */ 0
                                  }
                                }
                              }
                            }
                          }),
                        rows: rows,
                        styles: "flex-1 grid-cols-[repeat(8,_auto)] lg:grid-cols-7 overflow-y-auto auto-rows-min"
                      }),
                      count <= 0 ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                              className: "h-30",
                              alt: "buhta-zero-items",
                              src: StaticAsset.src("/static/icons/zero-items.svg")
                            }),
                            JsxRuntime.jsx(Buhta_components__Text.PLarge.make, {
                              className: "mt-6 w-[328px] text-asphalt text-center",
                              children: "В вашем предприятии пока нет сотрудников"
                            }),
                            JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                              route: contextRoute({
                                TAG: /* Hrm */ 5,
                                _0: {
                                  TAG: /* Employees */ 0,
                                  _0: /* Create */ 1
                                }
                              }),
                              className: "mt-4 text-links text-sm w-[328px] text-center",
                              children: [
                                "Добавьте новых сотрудников",
                                JsxRuntime.jsx("span", {
                                  children: ", чтобы удобно пользоваться продуктами",
                                  className: "text-asphalt"
                                })
                              ]
                            })
                          ],
                          className: "flex flex-col items-center col-span-3 mt-74"
                        }) : null
                    ],
                    className: "flex-1 overflow-auto"
                  }),
                  count <= 0 ? null : JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                      page: page,
                      setPage: setPage,
                      currentRecords: count
                    })
                ]
              }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
          )
      ],
      className: "flex flex-col w-full"
    })
  });
}

const make = HrmEmployeesPage;

export {
  HrmTableShimmer,
  make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
